/**
 * Default motor load list
 * Source: WWTP one-line electrical diagram analysis
 * 480V 3-phase, 1600A main, 65kAIC, EtherNet/IP DLR
 */
export const DEFAULT_LOADS = [
  // 15HP Process Pumps — NEMA Size 3 (40AF/40AT buckets)
  { id:"P1001A", tag:"P-1001A",     hp:15, nemaSize:3, description:"Process pump" },
  { id:"P1001B", tag:"P-1001B",     hp:15, nemaSize:3, description:"Process pump" },
  { id:"P1002A", tag:"P-1002A",     hp:15, nemaSize:3, description:"Process pump" },
  { id:"P1002B", tag:"P-1002B",     hp:15, nemaSize:3, description:"Process pump" },
  { id:"P1003",  tag:"P-1003",      hp:15, nemaSize:3, description:"Process pump" },
  { id:"CIP",    tag:"CIP Pump",    hp:15, nemaSize:3, description:"CIP pump w/ HTR" },
  { id:"P1004A", tag:"P-1004A",     hp:15, nemaSize:3, description:"Process pump" },
  { id:"P1004B", tag:"P-1004B",     hp:15, nemaSize:3, description:"Process pump" },
  // 75HP RO Pumps — NEMA Size 5 (200AF/200AT buckets)
  { id:"RO1A",   tag:"RO-1A Pump",  hp:75, nemaSize:5, description:"RO pump" },
  { id:"RO1B",   tag:"RO-1B Pump",  hp:75, nemaSize:5, description:"RO pump" },
  { id:"RO2A",   tag:"RO-2A Pump",  hp:75, nemaSize:5, description:"RO pump" },
  { id:"RO2B",   tag:"RO-2B Pump",  hp:75, nemaSize:5, description:"RO pump" },
  { id:"RO3",    tag:"RO-3 Pump",   hp:75, nemaSize:5, description:"RO pump" },
  // 3HP Air Handlers — NEMA Size 1 (20AF/20AT buckets)
  { id:"AH1",    tag:"AH-1",        hp:3,  nemaSize:1, description:"Air handler" },
  { id:"AH2",    tag:"AH-2",        hp:3,  nemaSize:1, description:"Air handler" },
  { id:"AH3",    tag:"AH-3",        hp:3,  nemaSize:1, description:"Air handler" },
  { id:"AH4",    tag:"AH-4",        hp:3,  nemaSize:1, description:"Air handler" },
  // Small loads
  { id:"SF1",    tag:"SF-1",        hp:0.25, nemaSize:0, description:"Small fan/pump" },
  // Control / feeder buckets (non-motor)
  { id:"CU1",    tag:"CU-1 (Ctrl)", hp:0, nemaSize:null, description:"Control unit feeder" },
  { id:"CU2",    tag:"CU-2 (Ctrl)", hp:0, nemaSize:null, description:"Control unit feeder" },
  { id:"CU3",    tag:"CU-3 (Ctrl)", hp:0, nemaSize:null, description:"Control unit feeder" },
  { id:"CU4",    tag:"CU-4 (Ctrl)", hp:0, nemaSize:null, description:"Control unit feeder" },
];
